import { ClassifierValue } from '@juvare/platform-sdk-react/ui/features/classifiers';
import React from 'react';
export function getClassifierValues(ids, entity) {
    return ids === null || ids === void 0 ? void 0 : ids.map((id, i, { length }) => (React.createElement("span", { key: id },
        React.createElement(ClassifierValue, { entity: entity, id: id }),
        length - 1 !== i && React.createElement("span", null, ", "))));
}
